
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DWTAEPD",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DWTAEPD.vue